import { render } from "./ModalCart.vue?vue&type=template&id=036538ce"
import script from "./ModalCart.vue?vue&type=script&lang=js"
export * from "./ModalCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__